import script from "./PersonLinkageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PersonLinkageModal.vue?vue&type=script&setup=true&lang=js"

import "./PersonLinkageModal.vue?vue&type=style&index=0&id=f4acb08c&lang=css"

const __exports__ = script;

export default __exports__